import React from 'react';
import PropTypes from 'prop-types';

import LandingPageHeader from 'components/LandingPage/Header';
import LandingPageFooter from 'components/LandingPage/Footer';

const LandingPageLayout = ({ children, loginContainer }) => (
  <main>
    <LandingPageHeader showLogin={loginContainer} />
    <div>{children}</div>
    <LandingPageFooter />
  </main>
);

LandingPageLayout.defaultProps = {
  loginContainer: true
};

LandingPageLayout.propTypes = {
  children: PropTypes.shape({}).isRequired,
  loginContainer: PropTypes.bool
};

export default LandingPageLayout;



// WEBPACK FOOTER //
// ./src/components/LandingPage/Layout.js